import { createI18n } from 'vue-i18n'
import storage from '@/plugins/storage'

let i18n = null

async function createI18nInstance() {
  // Determine initial language
  let selectedLanguage = 'en' // fallback language

  try {
    const sessionLang = await storage.local.getItem('SESSION_LANGUAGE')

    console.log('DEBUG => [i18n] Attempting to load SESSION_LANGUAGE:', sessionLang)
    if (sessionLang) {
      selectedLanguage = sessionLang
      console.log('DEBUG => [i18n] Using persisted SESSION_LANGUAGE:', selectedLanguage)
    } else if (window.config && window.config.language) {
      selectedLanguage = window.config.language
      console.log('DEBUG => [i18n] Using default config language:', selectedLanguage)
    } else {
      console.log('DEBUG => [i18n] No session or config language found. Using fallback "en".')
    }
  } catch (err) {
    console.warn('DEBUG => [i18n] Failed to load SESSION_LANGUAGE. Falling back to "en".', err)
  }

  function loadLocales() {
    const locales = require.context('../../../static/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    const messages = {}
    locales.keys().forEach(key => {
      const matched = key.match(/([A-Za-z0-9-_]+)\.json$/i)
      if (matched && matched[1]) {
        const locale = matched[1]
        const mod = locales(key)
        messages[locale] = mod.default || mod
      }
    })
    return messages
  }

  i18n = createI18n({
    legacy: false, // Composition API
    globalInjection: true,
    locale: selectedLanguage,
    fallbackLocale: 'en',
    messages: loadLocales(),
    missing: (locale, key) => {
      return key // return the key as-is
    }
  })
  return i18n;
}

export default createI18nInstance;
export function getI18nInstance() {
  return i18n
}
